import React from 'react';

const Flex = ({
    centre = false,
    spaceBetween = false,
    spaceAround = false,
    centreVertical = false,
    ...props
}) => (
    <div
        {...props}
        style={{
            display: 'flex',
            ...(centre
                ? {
                      justifyContent: 'center',
                      alignItems: 'center',
                      alignContent: 'center',
                      textAlign: 'center'
                  }
                : undefined),
            ...(spaceBetween
                ? {
                      justifyContent: 'space-between'
                  }
                : undefined),
            ...(spaceAround
                ? {
                      justifyContent: 'space-around'
                  }
                : undefined),
            ...(centreVertical
                ? {
                      alignItems: 'center'
                  }
                : undefined),
            ...props.style
        }}
    />
);

export default Flex;
